
import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { getBusinessSettings } from '@/utils/businessService';
import { createSafeHTML } from '@/utils/sanitizeHtml';

interface TermsDialogProps {
  children: React.ReactNode;
}

const TermsDialog: React.FC<TermsDialogProps> = ({ children }) => {
  const [termsContent, setTermsContent] = useState<string>('Loading terms...');
  
  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const settings = await getBusinessSettings();
        if (settings.terms) {
          setTermsContent(settings.terms);
        } else {
          setTermsContent('No terms and conditions have been set up. Please contact the administrator.');
        }
      } catch (error) {
        console.error('Error fetching terms:', error);
        setTermsContent('Error loading terms and conditions. Please try again later.');
      }
    };
    
    fetchTerms();
  }, []);
  
  return (
    <Dialog>
      <DialogTrigger asChild>
        {children}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[700px] max-h-[90vh]">
        <DialogHeader>
          <DialogTitle>Terms and Conditions</DialogTitle>
        </DialogHeader>
        <ScrollArea className="mt-4 max-h-[60vh] pr-4">
          <div className="space-y-4 text-sm" dangerouslySetInnerHTML={createSafeHTML(termsContent)} />
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};

export default TermsDialog;
